export const nurseryGenders = ['Male', 'Female', 'Others'] as const;
export const nurseryBloodGroups = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'] as const;
export const nurseryBabyStatuses = ['Alive', 'Still Born'] as const;
export const nurseryDeliveryModes = ['LUCS', 'NORMAL'] as const;

export interface NurseryDoctor {
  id: string;
  name: string;
}

export interface NurseryChild {
  id: string;
  babyId: number;
  name: string;
  guardianName: string | null;
  gender: (typeof nurseryGenders)[number];
  bloodGroup: (typeof nurseryBloodGroups)[number] | null;
  dateOfBirth: string | null;
  dateOfBirthYear: string | null;
  dateOfBirthMonth: string | null;
  dateOfBirthDay: string | null;
  address: string;
  state: string;
  district: string;
  pinCode: string | null;
  doctor: NurseryDoctor;
  diagnosis: string | null;
  operation: string | null;
  weight: string | null;
  babyStatus: (typeof nurseryBabyStatuses)[number];
  deliveryMode: (typeof nurseryDeliveryModes)[number] | null;
  admissionDate: string | null;
  dischargeDate: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface NurseryChildPayload {
  name: string;
  guardianName: string | null;
  gender: NurseryChild['gender'];
  bloodGroup: NurseryChild['bloodGroup'];
  dateOfBirth: string | null;
  dateOfBirthYear: string | null;
  dateOfBirthMonth: string | null;
  dateOfBirthDay: string | null;
  address: string;
  state: string;
  district: string;
  pinCode: string | null;
  doctor: string;
  diagnosis: string | null;
  operation: string | null;
  weight: string | null;
  babyStatus: NurseryChild['babyStatus'];
  deliveryMode: NurseryChild['deliveryMode'];
  admissionDate: string | null;
  dischargeDate: string | null;
}

export interface NurseryPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface NurseryListResponse {
  success: true;
  data: NurseryChild[];
  pagination: NurseryPagination;
}

export interface NurseryResponse {
  success: true;
  data: NurseryChild;
}

export interface NurseryLookupOption {
  id: string;
  label: string;
  code?: string;
}
